import { render } from "./UiContainer.vue?vue&type=template&id=6457d1ae"
import script from "./UiContainer.vue?vue&type=script&lang=js"
export * from "./UiContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__